var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 191,
    viewBox: "0 0 207 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5323 92.6931C34.3804 103.263 38.8833 112.219 32.3199 120.192C27.7307 125.764 7.89914 125.317 1.56581 139.084C-4.76752 152.852 8.70192 164.112 31.3157 168.031C53.9295 171.951 69.6033 174.854 81.564 184.312C93.5246 193.77 124.169 194.466 143.875 178.081C163.581 161.696 195.127 175.727 205.182 153.626C212.639 137.217 187.696 130.241 185.685 117.778C183.674 105.315 165.973 84.9137 140.251 93.658C114.528 102.402 70.1394 76.5486 48.5323 92.6931Z",
    fill: "#E55F5F",
    fillOpacity: 0.11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.71 125.706C140.549 123.615 140.549 121.554 142.533 118.591C146.252 112.854 148.385 105.99 148.385 98.2838C148.385 75.0477 129.004 56.2098 105.096 56.2098C81.1873 56.2098 61.8029 75.0372 61.8029 98.2838C61.7798 102.768 62.5509 107.221 64.0805 111.437C65.4141 115.043 65.9528 121.062 63.0058 124.009C59.9437 127.071 54.6381 127.56 52.7527 131.046C50.632 134.953 53.6235 140.358 62.9143 139.129C66.1516 138.7 74.7965 134.098 78.1462 138.75C80.6774 142.264 89.7303 150.075 101.469 145.237C115.278 139.552 121.005 139.613 128.023 141.498C140.25 144.78 149.863 140.156 150.71 135.803C151.986 129.226 142.871 127.806 141.71 125.706Z",
    fill: "#E65F5F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.79
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9588 84.6018C88.1385 81.0546 89.8195 76.1671 87.7132 73.6852C85.6069 71.2033 80.511 72.0669 76.3312 75.6141C72.1515 79.1614 70.4705 84.0489 72.5768 86.5308C74.6831 89.0127 79.779 88.1491 83.9588 84.6018Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5446 105.695C90.017 105.695 92.0213 103.69 92.0213 101.218C92.0213 98.7453 90.017 96.741 87.5446 96.741C85.0722 96.741 83.0679 98.7453 83.0679 101.218C83.0679 103.69 85.0722 105.695 87.5446 105.695Z",
    fill: "#070707"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.79
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.781 104.583C119.781 104.583 120.633 106.021 120.228 107.371C119.823 108.72 118.542 110.77 120.11 112.567C121.679 114.363 124.43 113.403 124.904 111.476C125.377 109.549 123.005 106.714 124.232 105.14C123.421 103.966 119.781 104.583 119.781 104.583Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.189 105.695C124.662 105.695 126.666 103.69 126.666 101.218C126.666 98.7453 124.662 96.741 122.189 96.741C119.717 96.741 117.713 98.7453 117.713 101.218C117.713 103.69 119.717 105.695 122.189 105.695Z",
    fill: "#070707"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5281 110.566C99.5281 110.566 100.645 107.261 104.933 107.261C109.222 107.261 110.205 110.566 110.205 110.566",
    stroke: "#070707",
    strokeWidth: 3.68094,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2864 52.9098L153.168 92.6931L165.657 7.67957C166.53 1.77248 159.802 -2.22573 155.025 1.3567L86.2864 52.9098Z",
    fill: "#FEA691"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1594 53.9992L79.5702 56.6715C78.5648 58.3621 79.1203 60.5477 80.8109 61.5531L148.173 101.614C149.864 102.619 152.049 102.063 153.055 100.373L154.644 97.7006C155.649 96.01 155.094 93.8244 153.403 92.819L86.041 52.7586C84.3504 51.7532 82.1648 52.3086 81.1594 53.9992Z",
    fill: "#FD8061"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.79
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.884 75.8766L117.713 66.157L76.9803 42.913L68.9395 56.2098L97.884 75.8766Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.135 31.6609C162.135 31.6609 152.86 64.3971 118.369 71.9934L153.168 92.6931L162.135 31.6609Z",
    fill: "#FEA691"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.023 39.5894L132.712 56.2098",
    stroke: "#FF8D76",
    strokeWidth: 5.31692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.503 27.8693L139.194 44.4897",
    stroke: "#FF8D76",
    strokeWidth: 5.31692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.318 47.7558L114.619 55.9143",
    stroke: "#FF8D76",
    strokeWidth: 5.31692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.707 68.4607L149.863 66.157",
    stroke: "#FF8D76",
    strokeWidth: 5.31692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.023 38.6454L144.265 32.7723",
    stroke: "#FF8D76",
    strokeWidth: 5.31692,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.465 145.852C53.6472 145.504 47.9519 147.324 47.1936 150.229C46.4353 153.134 52.6379 154.81 58.1763 154.337C64.0703 153.835 66.1256 151.461 65.7595 150.193C65.3934 148.924 62.7707 146.33 57.465 145.852Z",
    fill: "#E55F5F",
    fillOpacity: 0.51
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.624 146.775C129.731 147.185 128.844 151.346 131.702 152.865C134.56 154.384 142.557 153.268 142.424 150.632C142.29 147.996 138.852 146.223 133.624 146.775Z",
    fill: "#E55F5F",
    fillOpacity: 0.51
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.a86fc7f68c435f0edc2d6225e9ce2969.svg";
export { ForwardRef as ReactComponent };